module.exports = __webpack_public_path__ + "img/jubj.e953164b.svg";